import { useState, useEffect, useRef } from "react";
import PetInformation from "../PetInformation";

const BloodGlucose = () => {
  const [results, setResults] = useState([
    { analyte: "Canine Glucose", result: "", units: "mg/dl", reference: "76-119", comment: "False" },
    { analyte: "Feline Glucose", result: "", units: "mg/dl", reference: "60-120", comment: "False" },
    { analyte: "Equine Glucose", result: "", units: "mg/dl", reference: "NIL", comment: "False" },
  ]);

  const handleChange = (index: number, field: string, value: string) => {
    const updatedResults = [...results];
    updatedResults[index][field] = value;
    setResults(updatedResults);
  };

  return (
    <div className="overflow-x-auto ">
      <PetInformation />
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200 print:bg-white">
            <th className="border border-gray-300 px-4 py-2 text-xs ">Analytes</th>
            <th className="border border-gray-300 px-4 py-2 text-xs ">Results</th>
            <th className="border border-gray-300 px-4 py-2 text-xs ">Units</th>
            <th className="border border-gray-300 px-4 py-2  text-xs">Reference</th>
            <th className="border border-gray-300 px-4 py-2  text-xs">Comment & Image</th>
          </tr>
        </thead>
        <tbody>
          {results.map((row, index) => (
            <tr key={index}>
              <td className="border border-gray-300 px-4 py-2 text-xs ">{row.analyte}</td>
              <td className="border border-gray-300 px-4 py-2 bg-gray-100 print:bg-white text-xs">
                <input
                  type="text"
                  value={row.result}
                  onChange={(e) => handleChange(index, "result", e.target.value)}
                  className="w-full bg-transparent outline-none text-xs"
                />
              </td>
              <td className="border border-gray-300 px-4 py-2 bg-gray-100 print:bg-white text-xs">{row.units}</td>
              <td className="border border-gray-300 px-4 py-2 bg-gray-100 print:bg-white text-xs">{row.reference}</td>
              <td className="border border-gray-300 px-4 py-2 bg-gray-100 print:bg-white text-xs">
                <input
                  type="text"
                  value={row.comment}
                  onChange={(e) => handleChange(index, "comment", e.target.value)}
                  className="w-full bg-transparent outline-none text-xs"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex items-center gap-2 mt-3">
        <p className="text-xs">Doctor's Name:</p>
        <input type="text" className="text-sm w-[400px] border p-1" />
      </div>

      <p className=" mt-3 italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default BloodGlucose;
